// Module-level flag to track if auto-invoke has happened this session (persists across component remounts)
let hasAutoInvokedThisSession = false;

export function getAutoInvokeStatus(): boolean {
    return hasAutoInvokedThisSession;
}

export function setAutoInvokeStatus(status: boolean): void {
    hasAutoInvokedThisSession = status;
}

export function resetAutoInvokeStatus(): void {
    hasAutoInvokedThisSession = false;
}
